import React, { useMemo } from 'react';
import { Box, Typography, Chip, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import DataTable from '@/components/DataTable/DataTable';

const RoleUsersSection = ({ roleId }) => {
  const navigate = useNavigate();
  const userColumns = [
    {
      key: 'id',
      label: 'User ID',
      sortable: true,
      render: (value) => (
        <Typography variant='body2' sx={{ fontFamily: 'monospace' }}>
          {value}
        </Typography>
      ),
    },
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value) => (
        <Typography variant='body2' sx={{ fontWeight: 500 }}>
          {value}
        </Typography>
      ),
    },
    {
      key: 'email',
      label: 'Email',
      sortable: true,
      render: (value, row) => (
        <Link
          component='button'
          variant='body2'
          onClick={() => navigate(`/admin/usermanagement/${row.id}`)}
          sx={{
            textDecoration: 'none',
            cursor: 'pointer',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}>
          {value}
        </Link>
      ),
    },
    {
      key: 'status',
      label: 'Status',
      sortable: true,
      render: (value) => (
        <Chip
          label={value === 1 ? 'ACTIVE' : 'INACTIVE'}
          size='small'
          variant='outlined'
          color={value === 1 ? 'success' : 'warning'}
          sx={{ fontWeight: 500 }}
        />
      ),
    },
  ];

  const userFilters = useMemo(
    () => [
      {
        key: 'search',
        label: 'Search',
        filterType: 'search',
        placeholder: 'Search users by name or email...',
        debounce: true,
        debounceDelay: 300,
      },
    ],
    [],
  );

  if (!roleId) {
    return (
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant='body1' color='text.secondary'>
          Role ID is required to view assigned users
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Assigned Users
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
        View all users currently assigned to this role
      </Typography>

      <DataTable
        columns={userColumns}
        endpoint={`/roles/${roleId}/users`}
        initialSort={{ key: 'created_at', order: 'desc' }}
        pageSize={50}
        autoFetch={true}
        enableColumnPicker={true}
        enableSorting={true}
        enablePagination={false}
        enableFilters={true}
        columnFilters={userFilters}
        renderEmptyState={() => (
          <tr>
            <td colSpan={5} style={{ textAlign: 'center', padding: '3rem' }}>
              <Typography variant='h6' color='text.secondary'>
                No users assigned to this role
              </Typography>
            </td>
          </tr>
        )}
      />
    </Box>
  );
};

export default RoleUsersSection;
